import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 48 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children }) => (
  <p className="text-xs font-bold tracking-[0.25em] uppercase text-ember mb-6">{children}</p>
);
